import React, { useState, useEffect, useRef } from "react";
import "../../../../css/bs-stepper.css";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { IconSmartHome, IconUsers, IconCalendarEvent, IconPhoto, IconFileDescription, IconBuilding, IconPalette, IconSlideshow } from '@tabler/icons-react';
import "../Common/FormCss.css";
import { useAuth } from "../../../Context/store/context";
import StepHeader from "../Common/Step-Header";
import { _get } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import InvitationDetails from "../Common/Invitation-Details/InvitationDetails";
import CoupleDetails from "./Component/CoupleDetails";
import Events from "../Common/Events/Events";
import globals from "../../../../globals";
import Gallery from "../Common/Gallery/Gallery";
import Peoples from "../Common/People/Peoples";
import Stories from "../Common/Story/Stories";
import Studios from "../Common/Studio/Studios";
import ThemeCustomization from "../Common/Customization/ThemeCustomization";
import Save from "./Save";
import FetchAndBindData from "./BindData";
import { fetchadmininfo } from "../../../Redux/Actions/AdmininfoAction";
import TitleCustomizations from "../Common/TitleCustomizations/TitleCustomizations";
import { getDefaultTitles } from "./DefaultTitles";

export default function WeddingForm() {
  const Navigate = useNavigate();
  const { categoryId, themeId, id } = useParams();
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser, themeJsonData } = useAuth();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const dispatch = useDispatch();
  const [deletedImages, setDeletedImages] = useState([]);
  const [showTitleCustomization, setShowTitleCustomization] = useState(false);

  const eventSections = [
    {
      title: "Invitation Details", subTitle: "", data: null, isValid: false, sectionname: "invitation",
      icon: function () {
        return <IconSmartHome size={22} />
      }
    },
    {
      title: "Couple", subTitle: "Bride & Groom", data: null, isValid: false, sectionname: "couple",
      icon: function () {
        return <IconUsers size={22} />
      }
    },
    {
      title: "Events", subTitle: "Wedding, Reception etc.", data: null, isValid: false, sectionname: "events",
      icon: function () {
        return <IconCalendarEvent size={22} />
      }
    },
    {
      title: "Gallery", subTitle: "Memories", data: null, isValid: false, sectionname: "gallery",
      icon: function () {
        return <IconPhoto size={22} />
      }
    },
    {
      title: "People", subTitle: "Family Or Friends etc..", data: null, isValid: false, sectionname: "people",
      icon: function () {
        return <IconUsers size={22} />
      }
    },
    {
      title: "Story", subTitle: "Sweet Journey of Couple", data: null, isValid: false, sectionname: "story",
      icon: function () {
        return <IconFileDescription size={22} />
      }
    },
    {
      title: "Studio Profile", subTitle: "", data: null, isValid: false, sectionname: "studio",
      icon: function () {
        return <IconBuilding size={22} />
      }
    },
    {
      title: "Banners", subTitle: "", data: null, isValid: false, sectionname: "theme",
      icon: function () {
        return <IconSlideshow size={22} />
      }
    }
  ];


  const [sections, setSections] = useState([]);
  const [eventId, setEventId] = useState(0);
  const [eventCode, setEventCode] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [titles, setTitles] = useState(getDefaultTitles());
  const childRef = useRef();

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.wedding.title, globals.wedding.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      if (id) {
        fetchandBindData(id);
      }
      else {
        if (themeJsonData) {
          let titlesJson = JSON.parse(themeJsonData);
          setTitles(titlesJson);
        }
        setSections(eventSections);

      }
    }
  }, [userDetails, id]);

  const fetchandBindData = async (id) => {
    let result = await FetchAndBindData(id, eventSections);
    if (result) {
      setSections(result.sections);
      setEventId(result.eventId);
      setEventCode(result.eventCode);
      setTitles(result.titles);
    }
    else
      return Navigate("/invitations");
  }

  const handleSectionClick = (e, step) => {
    e.preventDefault();
    if (validateForm()) {
      let nextStep = currentStep + 1;
      while (nextStep < step) {
        if (sections[nextStep].isValid)
          nextStep++;
        else {
          let section = sections[nextStep];
          _showToast("Please provide information in " + section.title + " section", "warning");
          return;
        }
      }
      getAndUpdateData();
      setCurrentStep(step);
    } else {
      _showToast("Please provide information for all the required fileds before proceeding further", "warning");
    }
  };

  const insertDeletedImage = (imageKey) => {
    setDeletedImages(current => [...current, imageKey]);
  }

  const renderStep = () => {
    if (sections && sections.length > 0) {
      const section = sections[currentStep];
      switch (section.sectionname) {
        case "invitation":
          return (<InvitationDetails ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "couple":
          return (<CoupleDetails ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "events":
          return (<Events ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "gallery":
          return (<Gallery ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "people":
          return (<Peoples ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "story":
          return (<Stories ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "studio":
          return (<Studios ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "theme":
          return (<ThemeCustomization ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} save={saveHandler} imageDelete={insertDeletedImage} />);
      }
    }
  };

  const validateForm = () => {
    sections[currentStep].isValid = childRef?.current?.validate() ?? false;
    return sections[currentStep].isValid;
  }

  const getAndUpdateData = () => {
    const updatedSections = [...sections];
    updatedSections[currentStep]["data"] = childRef?.current?.getData() ?? null;
    setSections(updatedSections);
  }

  const saveHandler = async (e) => {
    e.preventDefault();
    await save(titles);
  }

  const save = async (titles) => {
    if (validateForm()) {
      getAndUpdateData();
      showLoader();
      if (await checkStatus()) {
        let result = await Save([...sections], themeId, categoryId, eventId, eventCode, deletedImages, titles);
        hideLoader();
        if (result.status == "success") {
          if (!eventId || (eventId && eventId == 0))
            updateEventCount();

          setEventCode(result.eventCode);
          setEventId(result.eventId);

          window.history.replaceState(null, "Edit Wedding Invitation | Invitd", "/invitations/wedding/" + result.eventId);
          window.open(result.eventUrl, "_blank");
          _showToast(result.message, "success");
        }
        else {
          if (result.message !== "")
            _showToast(result.message, "error");
        }
      }
    }
    else {
      _showToast("Please provide information for all the required fields before proceeding further", "warning");
    }
  }

  const checkStatus = async () => {
    if (!eventId || (eventId && eventId == 0)) {
      return await _get(`/events/check-status`)
        .then(async () => {
          return true;
        })
        .catch((error) => {
          hideLoader();
          _showToast(error, "error");
          return false;
        });
    }
    else
      return true;
  }

  const updateEventCount = () => {
    userDetails.eventCount = userDetails.eventCount + 1;
    dispatch(fetchadmininfo(userDetails));
  }

  const customizeThemeHandler = () => {
    setShowTitleCustomization(true);
  }

  const closeCustomizeModal = () => {
    setShowTitleCustomization(false);
  }

  const saveCustomizationHandler = async (titles) => {
    setTitles(titles);
    await save(titles);
    setShowTitleCustomization(false);
  }

  return (
    <>
      <div className="content-wrapper container-xxl flex-grow-1 container-p-y  ">
        <div className="card mb-3">
          <div className="card-body flex-sm-row d-flex align-items-sm-center flex-column py-sm-2">
            <nav aria-label="breadcrumb" className="flex-grow-1">
              <ol className="breadcrumb breadcrumb-style1 mb-0">
                <li className="breadcrumb-item ">
                  <NavLink to="/dashboard" className="text-gray">
                    Dashboard
                  </NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink className="text-gray" to="/invitations">
                    My Invitations
                  </NavLink>
                </li>
                {eventId == 0 && (
                  <>
                    <li className="breadcrumb-item">
                      <NavLink className="text-gray" to="/create-invitation">
                        Invitation Type
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink className="text-gray" to={"/create-invitation/themes/" + categoryId}>
                        Select Theme
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item text-primary">Wedding Invitation</li>
                  </>)}

                {eventId > 0 && (
                  <>
                    <li className="breadcrumb-item text-primary">Edit Invitation</li>
                  </>)}
              </ol>
            </nav>
            {eventId > 0 && (
              <div className="d-flex flex-row justify-content-end mt-4 mt-sm-0">
                <button
                  className="btn btn-primary btn-next"
                  onClick={customizeThemeHandler}>
                  Customize Theme
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="bs-stepper wizard-vertical wizard-numbered vertical mt-2">
          <div className="bs-stepper-header">
            {sections.map((section, index) => {
              const isActive = index === currentStep;
              let backgroundcolor = "text-gray";

              if (isActive) {
                backgroundcolor = "text-red";
              } else if (section.isValid) {
                backgroundcolor = "text-green";
              }

              return <StepHeader backgroundColor={backgroundcolor}
                Icon={section.icon}
                title={section.title}
                subTitle={section.subTitle}
                className={`step ${isActive ? "active" : ""}`}
                onClick={(e) => handleSectionClick(e, index)}
                key={index} />
            })}
          </div>
          <div className="bs-stepper-content">{renderStep()}</div>
        </div>
      </div>
      {
        showTitleCustomization && (
          <div>
            <TitleCustomizations
              onClose={closeCustomizeModal}
              onSave={saveCustomizationHandler}
              titles={titles}
            />
          </div>
        )
      }
    </>
  );
}
